export default {
  // ========== Selectores ==========
  typeFilterLabel: 'Tipo de {entity}',
  allOptions: 'Todos',
  clearFilters: 'Limpiar filtros',

  // ========== Reportes ==========
  report: 'Reporte de {entity}',
  download: 'Descargar',
  plansAndSubjectsReport: 'Reporte Planes y Asignaturas',
  plansAndEvaluationsReport: 'Reporte Planes y Evaluaciones',
  educationalTechnologyReport: 'Reporte Tecnología Educativa',
  mandatoryBibliographyReport: 'Reporte Bibliografía Obligatoria',
  valuationReport: 'Reporte de Valorización {entity}',
  mattersReport: 'Reporte de {entity}',

  // ========== Validaciones y mensajes ==========
  needToChooseAtLeastOne: 'Es necesario elegir al menos 1 {entity}',
  cannotChooseMoreThan: 'No es posible elegir más de {entity} {entity2}',
  cannotChooseMoreThan10: 'No es posible elegir más de 10 {entity}',

  // ========== Acciones de vista ==========
  showHideAll: '{action} los {entity}',
  goToAction: 'Dirigirse a...',

  // ========== Navegación ==========
  studyPlan: 'Plan de estudio',
  curricularMesh: 'Malla curricular',
  goToProfile: 'Ir al perfil',
  goToThe: 'Ir a la {entity}',
  goToStudyPlan: 'Ir al plan de estudio',
  academicLoad: 'Carga académica',
  goToAcademicLoad: 'Ir a la carga académica',
  goToCurricularMesh: 'Ir a la malla curricular',

  // ========== Campos de tabla ==========
  year: 'Año',
  curriculumNumber: 'Número de currículum',
  modality: 'Modalidad',
  programType: 'Tipo de programa',

  // ========== Reporte de {entity} ==========
  entryValidity: 'Entrada Vigencia',
  level: 'Nivel',
  shift: 'Jornada',
  grantedTitle: 'Título que otorga',
  duration: 'Duración',
  facultyArea: 'Área de {entity}',
  kf: 'KF',
  noData: 'No hay datos para mostrar',
  generatingExcel: 'Generando Excel...',
  pleaseWaitWhileGenerating: 'Por favor, espera mientras se genera el archivo.',
  downloadError: 'No se pudo descargar el archivo.',
  error: 'Error',
  generationError: 'Hubo un problema al generar el archivo.',

  // ========== Selección masiva ==========
  profilesSelected: '{count} perfil(es) seleccionado(s).',
  selectAllPrograms: '¿Seleccionar todos los {count} programas?',
  allSelected: '{count} perfiles seleccionados en total.',
  clearSelection: 'Limpiar selección',

  // ========== Mensajes de éxito ==========
  entityDeleted: '{entity} eliminado.',
}
